import { render, staticRenderFns } from "./matiere.vue?vue&type=template&id=6688baaf&scoped=true"
import script from "./matiere.js?vue&type=script&lang=js&external"
export * from "./matiere.js?vue&type=script&lang=js&external"
import style0 from "./matiere.vue?vue&type=style&index=0&id=6688baaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6688baaf",
  null
  
)

export default component.exports